import React, { useEffect, useState } from 'react';
import { ReadOnlyAPVStyle } from './ReadOnlyAPV.style';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios'; // Import axios for making HTTP requests
import SuccesCheckmark from '../../Components/SuccesCheckmark/SuccesCheckmark';
import printImg from "../../Assets/9004704_printer_print_printing_office_work_icon.svg"
import jumpImg from "../../Assets/9041819_jump_right_icon.svg"
import QRCodeComponent from '../../Components/QrCode/QrCode';
import realtimeImg from "../../Assets/7787508_duplicate_copy_documents_folder_file_icon.svg"
import clientpageImg from "../../Assets/9041305_person_lines_fill_icon.svg"
function ReadOnlyAPV(props) {
  const location = useLocation()
  const { id, key } = useParams()

  const navigate = useNavigate();
  const [num, setNum] = useState(0);
  const [newQuestion, setNewQuestion] = useState(null);
  const [textInput, setTextInput] = useState('');
  const [handleplanShow, setHandleplanShow] = useState([null,null]);
  const [translateError, setTranslateError] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const [language, setLanguage] = useState("en");
  const [prevLanguage, setPrevLanguage] = useState("en");
  const [hoverIndex, setHoverIndex] = useState(null);
  const [farmerId, setFarmerId] = useState(null);
  const [isPrint, setIsPrint] = useState(false);
  const [data, setData] = useState(null);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);
  const [success, setSuccess] = useState(false);
  const [realtime, setRealtime] = useState(false);
  const [docKey, setDocKey] = useState(false);
  const documentKey = false;
    const [documentData, setDocumentData] = useState(false);
console.log(id,key);
if (document.getElementById("toTop") && documentKey == "") {
  document.getElementById("toTop").style.display = "none"
}
if (document.getElementsByClassName("btnDiv")[0]) {
  document.getElementsByClassName("btnDiv")[0].style.display = "none"
}
 if (document.getElementById("modalBtn") && documentKey == "") {
   document.getElementById("modalBtn").style.display = "none"
 }
  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 768);
    };

    window.addEventListener('resize', handleResize);
   
   

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const addNewQuestion = (index) => {
    data[index].questions.push({ 
      question: textInput, 
      status: '', 
      deadline: "", 
      explanation: "", 
      problem: "", 
      responsible: ""});
    setNum(num + 1);
    setNewQuestion(null);
  };

  const deleteQuestion = (sectionIndex, questionIndex) => {
    const newData = [...data];
    newData[sectionIndex].questions.splice(questionIndex, 1);
    setData(newData);
  };

  const addStatus = (sectionIndex, questionIndex, status) => {
    const newData = [...data];
    newData[sectionIndex].questions[questionIndex].status = status;
    setData(newData);
    if (status === "Udfordring") {
          setHandleplanShow([sectionIndex, questionIndex])
    }

  };

  const addDeadline = (sectionIndex, questionIndex, deadline) => {
    const newData = [...data];
    newData[sectionIndex].questions[questionIndex].deadline = deadline;
    setData(newData);

  };

  const addExplantion = (sectionIndex, questionIndex, explanation) => {
    const newData = [...data];
    newData[sectionIndex].questions[questionIndex].explanation = explanation;
    setData(newData);

  };

  const addResponsible = (sectionIndex, questionIndex, responsible) => {
    const newData = [...data];
    newData[sectionIndex].questions[questionIndex].responsible = responsible;
    setData(newData);

  };

  useEffect(() => {
    const authDocument = async () => {
      try {
 
        const response2 = await axios.get(`https://api.agrop.eu/authDoc?id=${id}&key=${key}`);
        setDocKey(response2.data)
        if (!response2.data) {
                  setData({
          "APV": []
      })
        }

        console.log(response2.data);
        
      } catch (error) {
        console.log(error);
      }
    };
    authDocument();
    
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`https://api.agrop.eu/getApv/${id}`);
        setData(response.data.content.APV || response.data.content);
        console.log(data);
        setDocumentData(response.data)
        setFarmerId(response.data.clientId);
        console.log(response.data);
        
      } catch (error) {
        console.log(error);
      }
    };

if (docKey) {
  fetchData();
}
    
    
  }, [docKey]);
  // useEffect(() => {
  //   let interval;
  //   // Start the interval if realtime is true
  //   if (realtime) {
  //     interval = setInterval(() => {
  //       const fetchData = async () => {
  //         try {
  //           const response = await axios.get(`https://api.agrop.eu/getApv/${id}`);
  //           setData(response.data.content);
  //           console.log(response.data.content[0]);
  //         } catch (error) {
  //           console.log(error);
  //         }
  //       };
  //       fetchData();
  //     }, 5000);
  //   }
  
  //   // Clean up the interval when the component unmounts or realtime changes
  //   return () => {
  //     clearInterval(interval);
  //   };
  // }, [realtime]);
  useEffect(() => {

      const h2Elements = Array.from(document.querySelectorAll('h2'));
    const optionElements = h2Elements.map((item, index) => (
      <p key={index} onClick={() => {document.getElementById(item.innerText.replace(' ', '-')).scrollIntoView({ behavior: 'smooth' }); setModalOpen(false)}}>{item.innerText}</p>
    ));
    setOptions(optionElements);

    
  }, [data]);

  const translateText = async (text) => {
    try {
      const response = await axios.post('https://lang.kvægapv.eu/translate', { text, targetLanguage: language, startLanguage: prevLanguage });
      return response.data.translatedText;
    } catch (error) {
      console.error('Translation error:', error);
      throw error;
    }
  };

  const translateAndAddQuestion = async (index) => {
    try {
      const translatedQuestion = await translateText(textInput);
      data[index].questions.push({ 
        question: translatedQuestion, 
        status: '', 
        deadline: "", 
        explanation: "", 
        problem: "", 
        responsible: "" 
      });
      setNum(num + 1);
      setNewQuestion(null);
    } catch (error) {
      // Handle translation error
      console.error('Translation error:', error);
      setTranslateError(true)
    }
  };

  const translateWholePage = async () => {
    try {
      const textElements = Array.from(document.querySelectorAll('p, h1, h2, h3, h4, h5, h6, button'));
      for (let i = 0; i < textElements.length; i++) {
        const text = textElements[i].innerText;
        const translatedText = await translateText(text);
        textElements[i].innerText = translatedText;
      }
    } catch (error) {
      console.error('Translation error:', error);
    }
  };
  const updateAPV = async (id,content) => {
    console.log(id);
    try {
        const response = await axios.put(`https://api.agrop.eu/updateapv/${id}`, {
            content: JSON.stringify(content), // Ensure content is stringified
            userId: JSON.parse(sessionStorage.getItem('user')).id || 0,
        });
        //console.log('APV updated successfully:', response.data);
              setTimeout(() => {
        setSuccess(true); // After 1 second, set success to true
        setTimeout(() => {
          setSuccess(false); // After 1 second, set success to false
        }, 1500);
      }, 200);

    } catch (error) {
        console.error('Update error:', error);
        throw error;
    }
};
  return (
    <ReadOnlyAPVStyle>
      {success && <SuccesCheckmark />}
{ data ?      <>
<div className='btnDiv2'>
      <span id='theTop'></span>
      <button id='toTop' onClick={() => document.getElementById('theTop').scrollIntoView({ behavior: 'smooth' })}>⬆️</button>
      <button id='modalBtn' style={{display: !isDesktop ? "none" : "block"}} onClick={() => setModalOpen(modalOpen ? false : true)}>{'Hop til'}</button>

      </div>
      <div className='btnDiv'>
      {/* <button onClick={translateWholePage}>Translate Page</button>
      <select onChange={(e) => {
        setPrevLanguage(language)
        setLanguage(e.target.value)
        
        }} name="" id="">
        <option value="da">Dansk</option>
        <option value="pl">Polsk</option>
        <option value="es">Spansk</option>
        <option value="fr">Fransk</option>
        <option value="en">Engelsk</option>
        <option value="uk">Ukrainsk</option>
      </select> */}
      <button style={{display: !isDesktop ? "none" : "block"}} onClick={() => {
        document.getElementsByClassName('btnDiv2')[0].style.display = "none"
        document.getElementsByClassName('btnDiv')[0].style.display = "none"

        for (let index = 0; index < document.getElementsByClassName('headingArt').length; index++) {
          document.getElementsByClassName('headingArt')[index].style.gridTemplateColumns = "10% 40% 10% 10% 10% 20%";
          
        }
        document.getElementsByTagName('header')[0].style.display = "none"
        document.getElementsByTagName('header')[1].style.display = "none"
        document.getElementsByClassName('fbQhXJ')[0].style.display = "none"
        document.getElementsByClassName('desktopForm')[0].style.width = "90vw"
        document.getElementsByClassName('desktopForm')[0].style.marginLeft = "5vw"
        document.getElementsByClassName('desktopForm')[0].style.marginTop = "2vw"
        document.getElementsById('printBtn').style.display = "none"
        setIsPrint(true)
        setTimeout(() => {
          window.print()
        }, 200);
        
        setTimeout(() => {
          document.getElementsByClassName('btnDiv2')[0].style.display = "block"
          document.getElementsByClassName('btnDiv')[0].style.display = "grid"
          for (let index = 0; index < document.getElementsByClassName('headingArt').length; index++) {
            document.getElementsByClassName('headingArt')[index].style.gridTemplateColumns = "50% 10% 10% 10% 20%";
            
          }
          document.getElementsByTagName('header')[0].style.display = "block"
          document.getElementsByTagName('header')[1].style.display = "block"
          document.getElementsByClassName('fbQhXJ')[0].style.display = "block"
          document.getElementsByClassName('desktopForm')[0].style.width = "100%"
          // document.getElementsByClassName('desktopForm')[0].style.marginLeft = "12.5rem"
          document.getElementsById('printBtn').style.display = "fixed"
          setIsPrint(false)
        }, 200);
      }}> <img src={printImg} alt="Print" /> </button>
      <button onClick={() => setModalOpen(modalOpen ? false : true)}><img src={jumpImg} alt="Hop til" /></button>
      <button style={{ backgroundColor: realtime ? "green" : "white"}} onClick={() => realtime ? setRealtime(false) : setRealtime(true)} > <img src={realtimeImg} alt="realtime" /> </button>

      </div>
            <button id='printBtn' style={{display: !isDesktop ? "none" : "block"}} onClick={() => {
        document.getElementsByClassName('btnDiv2')[0].style.display = "none"
        document.getElementsByClassName('btnDiv')[0].style.display = "none"

            document.getElementsByClassName('categoryDiv')[0].style.gridTemplateColumns = "40% 12% 12% 12% 24%";
            for (let index = 0; index < document.getElementsByClassName('headingArt').length; index++) {
              document.getElementsByClassName('headingArt')[index].style.gridTemplateColumns = "0% 40% 12% 12% 12% 24%";
          
        }
        document.getElementById('printBtn').style.display = "none"
        document.getElementsByClassName('desktopForm')[0].style.width = "100vw"
        document.getElementsByClassName('desktopForm')[0].style.marginLeft = "0vw"
        document.getElementsByClassName('desktopForm')[0].style.marginTop = "0vw"
        setIsPrint(true)
        setTimeout(() => {
          window.print()
        }, 200);
        
        setTimeout(() => {
          document.getElementsByClassName('btnDiv2')[0].style.display = "block"
          document.getElementsByClassName('btnDiv')[0].style.display = "grid"
            document.getElementsByClassName('categoryDiv')[0].style.gridTemplateColumns = "50% 7% 7% 7% 29%";
            for (let index = 0; index < document.getElementsByClassName('headingArt').length; index++) {
              document.getElementsByClassName('headingArt')[index].style.gridTemplateColumns = "0% 50% 7% 7% 7% 29%";
            
          }
          document.getElementById('printBtn').style.display = "block"
          document.getElementsByClassName('desktopForm')[0].style.width = "100%"
          // document.getElementsByClassName('desktopForm')[0].style.marginLeft = "5rem"
          setIsPrint(false)
        }, 200);
      }}> <img src={printImg} alt="Print" /> </button>
      {modalOpen && (
        <div className="modal">
          <div className="modal-content">
            {options}
          </div>
        </div>
      )}
 
     { !isDesktop ? docKey ? <section key={num} className='mobileForm'>
        {data.length > 0 ? data.map((item, index) => (
          <React.Fragment key={index}>
            <h2 id={item.heading.replace(' ', '-')}>{item.heading}</h2>
            {item.questions.map((question, qIndex) => (
              <div key={qIndex}>
                <p></p>
                <p>{question.question}</p>
                <button
                  style={{ backgroundColor: question.status === 'Udfordring' ? 'red' : 'initial' }}
                  
                >
                  Udfordring
                </button>
                <button
                  style={{ backgroundColor: question.status === 'I orden' ? 'green' : 'initial' }}
                  
                >
                  I orden
                </button>
                <button
                  style={{ backgroundColor: question.status === 'Irrelevant' ? 'gray' : 'initial' }}
                 
                >
                  Irrelevant
                </button>
              </div>
            ))}
          </React.Fragment>
        )) : <h2>Denne rapport er tom</h2>}
      </section> : <h1 style={{marginTop: "40vh", width: "100%"}}>Du har ikke tilladelse til at se denne rapport</h1>
      :
docKey ? <section key={num} className='desktopForm'>
  
  {data.map((item, index) => (
    <React.Fragment key={index}>
      
      <div>
        <div className='categoryDiv' style={{display: data[index].questions.length > 0 ? "grid" : "none"}}>
          <h2 id={item.heading.replace(' ', '-')} style={{backgroundColor: "#D9D9D9", borderLeft: "solid black 1px"}}>{item.heading}</h2>
          <p style={{backgroundColor: "#CF4040"}}>Udfordring</p>
          <p style={{backgroundColor: "#28C253"}}>I orden</p>
          <p style={{backgroundColor: "#B8B8B8", borderRight: "solid black 1px"}} >Irrelevant</p>
                              <p style={{backgroundColor: "#0099ff"}}>Kommentar</p>
        </div>
        {item.questions.map((question, qIndex) => (
          <React.Fragment key={`${index}-${qIndex}`}>
            <article className='headingArt'>
              <p style={{paddingTop: "1vh"}} ></p>
              <div>
                <span ><p>{question.question}</p><p>{isPrint ? " " : " "}</p></span>
              </div>
              <div style={{borderRight: "solid black 1px", borderLeft: "solid black 1px"}} >{question.status === "Udfordring" ? "x" : ""}</div>
              <div style={{borderRight: "solid black 1px"}} >{question.status === "I orden" ? "x" : ""}</div>
              <div style={{borderRight: "solid black 1px"}} >{question.status === "Irrelevant" ? "x" : ""}</div>
              <div ><textarea defaultValue={question.comment} disabled ></textarea></div>
            </article>
          </React.Fragment>
        ))}
        
      </div>
      
    </React.Fragment>
  ))}
  {/* <h1 style={{marginTop: "10%"}}>Link til rapport</h1>
  <input type="text" value={`https://api.agrop.eu/readapv/${documentData.id}/${documentData.documentKey}`} style={{width: "50%"}} /> */}
</section> : <h1 style={{marginLeft: "20vw", width: "100%"}}>Du har ikke tilladelse til at se denne rapport</h1>


}
     
      </> : <h2 style={{position: "absolute", left: "38vw", top: "40vh"}}>Henter rapporten...</h2>}
    </ReadOnlyAPVStyle>
  );
}

export default ReadOnlyAPV;
